import { Logo } from "@/components/Logo";
import { Reveal } from "@/components/Reveal";

export function MeetTheBees() {
  return (
    <section className="bg-[#FAF5EE] overflow-hidden" data-testid="meet-the-bees-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-5 flex justify-center">
            <Reveal>
              <div className="relative rotate-[-3deg] hover:rotate-0 transition-transform duration-500" data-testid="bees-polaroid">
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-28 h-8 bg-[#EDE0CF]/90 rotate-[2deg] shadow-sm z-10 rounded-sm" />
                <div className="bg-white p-4 pb-6 rounded-2xl shadow-xl border border-[#E6D7C3]">
                  <img
                    src="/images/our-bees.jpg"
                    alt="Our actual bees gathered for a drink at their dish"
                    className="rounded-xl w-full max-w-sm object-cover"
                    data-testid="bees-photo"
                  />
                  <p className="mt-4 text-center font-serif-display italic text-lg text-[#5A4D44]" data-testid="bees-caption">
                    The girls, caught mid-sip
                  </p>
                </div>
                <div className="absolute -bottom-4 -right-4 animate-float-bee">
                  <Logo size={44} />
                </div>
              </div>
            </Reveal>
          </div>

          <div className="md:col-span-7">
            <Reveal delay={0.1}>
              <p className="font-mono-accent text-xs uppercase tracking-[0.25em] text-[#D97706] font-semibold" data-testid="bees-overline">
                Meet the Bees
              </p>
              <h2 className="mt-4 font-serif-display text-2xl sm:text-3xl lg:text-4xl font-bold text-[#2C221E] tracking-tight" data-testid="bees-heading">
                The hardest workers in the family
              </h2>
              <p className="mt-5 text-base text-[#5A4D44] leading-relaxed max-w-xl" data-testid="bees-text">
                These are our actual bees — not a stock photo in sight. Here they are gathered around their
                dish for a well-earned drink. Every candle, balm, soap, and lotion in our shop starts with
                wax from these busy little ladies and their two hives.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                {["Our real bees", "Two happy hives", "More joining in 2027"].map((t) => (
                  <span
                    key={t}
                    className="px-4 py-2 rounded-full bg-[#F3EBE0] border border-[#E6D7C3] text-xs font-semibold text-[#78350F]"
                    data-testid={`bees-chip-${t.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
